// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import setIsUpdatingCheckout from "@bg/App/Handlers/OnePageCheckout/SetIsUpdatingCheckout";
import {
    addToChainAfter,
    addToEndOfChain,
    addToStartOfChain,
    executeAwaitableHandlerChain,
    StrictInputDispatch,
} from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    chain,
    LoadShipTos,
    SetPaymentDetailsState,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetInitialValues";

const DispatchStartCheckoutLoading: typeof LoadShipTos = props => {
    props.dispatch(setIsUpdatingCheckout({ isUpdatingCheckout: true }));
};

const setInitialValues = ({
    state,
    cart,
    dispatch,
}: {
    state: ApplicationState;
    dispatch: StrictInputDispatch;
    cart?: Cart;
}) => {
    const shippingAddressFormState = state.pages.onePageCheckout.shippingAddressFormState;
    const values = { useOneTimeAddress: false, useBillingAddress: false };
    if (shippingAddressFormState?.address.oneTimeAddress) {
        dispatch({
            type: "xOnePageCheckout/SetUseOneTimeAddress" as any,
            useOneTimeAddress: true,
        });
        values.useOneTimeAddress = true;
    } else if (shippingAddressFormState?.address.id === cart?.billToId) {
        dispatch({
            type: "xOnePageCheckout/SetUseBillingAddress" as any,
            useBillingAddress: true,
        });
        values.useBillingAddress = true;
    }

    return values;
};

export const DispatchSetLastSelectedShipTo: typeof LoadShipTos = props => {
    const { useOneTimeAddress } = setInitialValues({
        state: props.getState(),
        dispatch: props.dispatch,
        cart: props.cart,
    });

    if (useOneTimeAddress) {
        return;
    }

    props.dispatch({
        type: "xOnePageCheckout/SetLastSelectedShipTo" as any,
        shipTo: props.shipTo,
    });
};

const InitialValues: typeof SetPaymentDetailsState = props => {
    setInitialValues({
        state: props.getState(),
        dispatch: props.dispatch,
        cart: props.cart,
    });
};

const DispatchFinishCheckoutLoading: typeof LoadShipTos = props => {
    props.dispatch(setIsUpdatingCheckout({ isUpdatingCheckout: false }));
};

addToStartOfChain(chain, DispatchStartCheckoutLoading);
addToChainAfter(chain, LoadShipTos, DispatchSetLastSelectedShipTo);
addToChainAfter(chain, SetPaymentDetailsState, InitialValues);
addToEndOfChain(chain, DispatchFinishCheckoutLoading);
